const yup = require('yup')

export const Bulkschema = yup.object().shape({
  min: yup.number().min(1, 'minOneErr').required('minErr'),
  max: yup.number().min(1, 'minOneErr').moreThan(yup.ref('min'), 'maxMinErr').required('maxErr'),
  value: yup.number().required('valueErr'),
})
